import { arrangementSchema } from 'schemas/arrangement';
import { courseSchema } from 'schemas/course';
import { nonEmptyString } from 'schemas/common';
import { requiredCredentialSchema } from 'schemas/required-credential';
import { z } from 'zod';

export const articulationSchema = z.object({
  ID: nonEmptyString,
  arrangements: z.array(arrangementSchema),
  course: courseSchema,
  requiredCredentials: z.array(requiredCredentialSchema),
});
